import { render } from "./DisclaimerView.vue?vue&type=template&id=7f11b012&scoped=true"
import script from "./DisclaimerView.vue?vue&type=script&lang=js"
export * from "./DisclaimerView.vue?vue&type=script&lang=js"

import "./DisclaimerView.vue?vue&type=style&index=0&id=7f11b012&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f11b012"]])

export default __exports__